var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInnFlowLaborLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8367 2.73305H4.20459V0.525587C4.20459 0.318272 4.27393 0.169356 4.41163 0.0817579C4.49562 0.0272526 4.60402 0 4.71828 0C4.8218 0 4.93021 0.0233594 5.02884 0.0681316L10.8367 2.73305Z",
    fill: "#4027C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7202 3.12402L4.79316 5.84442C4.56268 5.94954 4.36346 6.06536 4.20427 6.21525C4.13005 6.28338 4.06462 6.3593 4.00895 6.44398C3.92008 6.5783 3.85465 6.735 3.81363 6.92479C3.7814 7.07176 3.7648 7.2382 3.7648 7.42897V16.9226H1.03715C0.464862 16.9226 0 16.4584 0 15.889V4.15768C0 3.58732 0.464862 3.12402 1.03715 3.12402H10.7202Z",
    fill: "#5438DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4813 3.30859V16.9602L11.4324 16.9826L11.199 17.0897L11.1424 17.1159L10.7156 17.3116L5.18412 19.85C4.84524 20.0086 4.56398 20.0437 4.41065 19.9463C4.27295 19.8597 4.25244 19.6689 4.25244 19.5638V7.42764C4.25244 6.74145 4.48194 6.52051 4.99661 6.28497L11.4666 3.31541L11.4822 3.30859H11.4813Z",
    fill: "#8160FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnFlowLaborLogo);
export default __webpack_public_path__ + "static/media/inn-flow-labor-logo.60f6935e3dc3f94167f7f63d82280269.svg";
export { ForwardRef as ReactComponent };